import React, { memo, useCallback } from 'react'
import * as ReactDOMServer from 'react-dom/server';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import PropTypes from 'prop-types';

export const MultiCheckBox = memo(({ name, value, onChange, list = [] }) => {
  const handleChange = useCallback(
    cbname => () => {
      const newVal = { ...value, [cbname]: !value[cbname] }
      return onChange({ target: { name, value: newVal } })
    },
    [name, onChange, value],
  )


  return (
    <div className="space-y-5">
      {list.map(x => (
        <div className="flex items-center space-x-4">
          <div
            key={x.name}
            className="flex items-center cursor-pointer hover:text-red-600 text-base text-slate-600 transition-all duration-300"
            onClick={handleChange(x.name)}
          >
            <input
              id={x.name}
              name={x.name}
              className="hidden"
              onChange={() => { }}
              checked={value[x.name]}
              type="checkbox"
            />
            <span className='transition duration-300' />
            {x.label}
          </div>
          <div className="">
            {x.info &&
              <div className="w-44">
                <ReactTooltip
                  className='w-full md:w-[40%] z-50'
                  clickable
                  id="tooltip-multicheckbox"
                  place="top"
                  type="dark"
                  effect="solid"
                />
                <div className="border border-red-700 text-red-700 w-6 h-6 rounded-full text-center cursor-pointer" data-tooltip-id="tooltip-multicheckbox" data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
                  x.info
                )}>
                  ?
                </div>
              </div>
            }
          </div>
        </div>
      ))}
    </div>
  )
})

MultiCheckBox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  onChange: PropTypes.func
}